
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4F71E8","d":"M4.362 15.164c2.456-1.633 5.196-2.996 7.757-4.366 4.406-2.244 8.829-4.449 13.297-6.501.869-.35 2.43-.692 2.584.863-.084 2.202-.429 4.39-.666 6.58-.6 4.813-1.294 9.61-1.971 14.407-.233 1.598-1.891 2.426-2.952 1.403-2.55-2.08-5.119-4.139-7.636-6.266-.824-1.011-.06-2.464.677-3.186 2.1-2.5 4.326-4.622 6.316-7.25.732-1.348-1.049-.246-1.572.159-2.875 2.391-5.679 4.93-8.71 7.031-1.548 1.03-3.352.15-4.9-.424-1.387-.694-3.42-1.393-2.224-2.45z"}})])
          )
        }
      }
    